import { Box, Slider, Typography } from '@mui/material';
import {
    CALL_PRIORITY_MARKS,
    getCallPriorityColor,
    getCallPriorityLabel,
    normalizeCallPriority
} from '../../utils/callPriority';

const CallPriorityField = ({ value, onChange, disabled = false, sx = {} }) => {
    const normalizedValue = normalizeCallPriority(value);
    const accentColor = getCallPriorityColor(normalizedValue);
    const sliderMarks = CALL_PRIORITY_MARKS.map((mark, index) => ({
        value: index,
        label: mark.label
    }));
    const sliderValue = Math.max(
        0,
        CALL_PRIORITY_MARKS.findIndex((mark) => mark.value === normalizedValue)
    );

    return (
        <Box
            sx={{
                px: 1.5,
                py: 1.25,
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: 1,
                ...sx
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    mb: 0.75
                }}
            >
                <Typography variant="body2" fontWeight={700} color="#3D3D3D">
                    Prioridade de Chamada
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        px: 1,
                        py: 0.35,
                        borderRadius: 999,
                        bgcolor: `${accentColor}14`,
                        color: accentColor,
                        fontWeight: 700,
                        flexShrink: 0
                    }}
                >
                    {getCallPriorityLabel(normalizedValue)}
                </Typography>
            </Box>

            <Box sx={{ maxWidth: 320, width: '100%', px: 0.75, mx: 'auto' }}>
                <Slider
                    value={sliderValue}
                    min={0}
                    max={sliderMarks.length - 1}
                    step={null}
                    marks={sliderMarks}
                    disabled={disabled}
                    onChange={(_, nextValue) =>
                        onChange(CALL_PRIORITY_MARKS[Number(nextValue)]?.value ?? normalizedValue)
                    }
                    sx={{
                        color: accentColor,
                        mt: 0.25,
                        mb: 2.5,
                        '& .MuiSlider-rail, & .MuiSlider-track': {
                            height: 4
                        },
                        '& .MuiSlider-thumb': {
                            width: 14,
                            height: 14
                        },
                        '& .MuiSlider-mark': {
                            width: 5,
                            height: 5,
                            borderRadius: '50%',
                            backgroundColor: '#B9B9B9',
                            opacity: 1
                        },
                        '& .MuiSlider-markActive': {
                            backgroundColor: accentColor
                        },
                        '& .MuiSlider-markLabel': {
                            top: 26,
                            transform: 'translateX(-50%)',
                            fontSize: '0.78rem',
                            fontWeight: 600,
                            color: '#6B6B6B',
                            whiteSpace: 'nowrap'
                        },
                        '& .MuiSlider-markLabelActive': {
                            color: accentColor,
                            fontWeight: 700
                        },
                        '& .MuiSlider-markLabel[data-index="0"]': {
                            transform: 'translateX(-50%)'
                        }
                    }}
                />
            </Box>
        </Box>
    );
};

export default CallPriorityField;
